import React, {useState, useEffect} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import isEmail from 'validator/lib/isEmail';
import CartInputField from '../Components/Cart/CartInputField';

function NewsletterPopup (props) {
  const [FormEmail, setFormEmail] = useState("");
  const [PrivacyOption, setPrivacyOption] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [NetError, setNetError] = useState(null);
  const [ErrorList, setErrorList] = useState([]);
  const [Message, setMessage] = useState("");

  useEffect(() => {
    setMessage("");    
  }, [FormEmail, PrivacyOption]);


  function registerHandler() {
    var errList = [];

    if ((FormEmail.trim().length === 0) || (!isEmail(FormEmail)) )
      errList.push({id: "Email", msg: "Inserire un indirizo di email valido."});
    if (PrivacyOption !== true)
      errList.push({id: "CkPrivacy", msg: "E' necessario accettare la privacy policy per proseguire."});

    setErrorList(errList);
    //console.log(errList);
  
    if (errList.length > 0) {
      setMessage("La compilazione dei dati è errata. Segui le indicazioni e riprova!");
      return;
    } else {
      setMessage("");
    }
    let params = [
        {name: "id_sessione", value: props.sessionKey},
        {name: "mail", value: FormEmail},
      ];   
      props.wsCall(
        "https://ws.mediatoys.it/cliente/add_cliente_fast",
        IsLoading,
        setIsLoading,
        NetError,
        (message) => {
          if (message) {
            const myArr = message.split(" ");
            if (myArr[myArr.length - 1] === "400") {
              // duplicated email error => ignore it
              setMessage("Registrazione avvenuta con successo.");
            } else 
              setNetError(message);
          }
        },
        params,
        (respData) => {
          console.log(respData);
          let txt = "Registrazione avvenuta con successo. Ti abbiamo inviato una e-mail contenente i tuoi dati di accesso.";
          setMessage(txt);
        }
      );  
  }

  //console.log(Message);
  //console.log(ErrorList);
  return (
    <Dialog open={true}>
      <DialogTitle>Iscriviti alla Newsletter di Bburago-shop!</DialogTitle>
      <DialogContent>
        <p>Basta inserire il tuo indirizzo e-mail nel campo sottostante:</p>

        <CartInputField
          required={true}
          type="text"
          lbl=""
          name="Email"
          placeholder="E-mail"
          value={FormEmail}
          change={setFormEmail}
          cssClass="riga_info_cart"
          errList={ErrorList}
        />
        {Message.length === 0 || ErrorList.length > 0 ? (
          <CartInputField
            required={true}
            type="checkbox"
            lbl="Ho preso visione e accetto l'informativa sulla Privacy"
            name="CkPrivacy"
            value={PrivacyOption}
            change={setPrivacyOption}
            cssClass="privacy_cart"
            labelRight={true}
            //url="/privacy"
            url={props.privacyUrl}
            urlText="leggi"
            errList={ErrorList}
          />
        ) : null}
        {Message.length > 0 ? <p>{Message}</p> : null}
        {Message.length === 0 || ErrorList.length > 0 ? (
          <div
            className="accedi_popup_button"
            onClick={() => registerHandler()}
          >
            Registrami
          </div>
        ) : null}
        <div
          className="chiudi_popup_button"
          onClick={() => props.closeHandler()}
        >
          Chiudi
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default NewsletterPopup;